import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ExcelModule, PDFModule } from '@progress/kendo-angular-grid';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UploadModule } from '@progress/kendo-angular-upload';

import { DataGridComponent } from './data-grid.component';
import { ColumnTemplatePipe } from './data-grid.pipe';
import { ConfigurationComponent } from './configuration/configuration.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { ConfigurationService } from './configuration/configuration.service';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DateRangeFilterComponent } from './date-range-filter.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonGroupModule,
        ButtonsModule,
        ReactiveFormsModule,
        GridModule,
        ExcelModule,
        PDFModule,
        SwitchModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        NumericTextBoxModule,
        MatTooltipModule,
        DialogModule,
        UploadModule,
        PopupModule,
        DateInputsModule,
    ],
    declarations: [
        DataGridComponent,
        ConfigurationComponent,
        DateRangeFilterComponent,
        ColumnTemplatePipe
    ],
    exports: [
        DataGridComponent
    ],
    providers: [ConfigurationService]
})
export class DataGridModule { }
